import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 0,
      name: i18n.tc('clients.expire_password_months', 0)
    },
    {
      id: 6,
      name: i18n.tc('clients.expire_password_months', 6)
    },
    {
      id: 12,
      name: i18n.tc('clients.expire_password_months', 12)
    }
  ]
}

function GenerateConfigGrid () {
  return [
    {
      id: null,
      name: i18n.tc('clients.expire_password_months', 0)
    },
  ]
}

export function MESES_USER_PASS_CADUC_GRID (state) {
  return configHelper.getConfig(state, 'MESES_USER_PASS_CADUC_GRID', GenerateConfigGrid)
}

export function MESES_USER_PASS_CADUC (state) {
  return configHelper.getConfig(state, 'MESES_USER_PASS_CADUC', GenerateConfig)
}
